// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=38a6f3be-8402-48bd-8ac0-e9b742c53419";
};